<template>
  <div class="hashtag-manager-page">
    <h2>Create Central Hashtag</h2>
    <div class="d-flex mb-4">
      <input
        type="text"
        v-model="newHashtag"
        class="form-control mr-2"
        placeholder="Enter hashtag (no #)"
      />
      <button
        class="btn btn-success"
        @click="createHashtag"
        :disabled="!newHashtag || isAdding"
      >
        <span v-if="isAdding">Adding...</span>
        <span v-else>Add</span>
      </button>
    </div>
    <div v-if="message" class="alert alert-info mt-2">{{ message }}</div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HashtagManager",
  data() {
    return {
      newHashtag: "",
      isAdding: false,
      message: "",
      auth: {
        headers: {
          "Content-Type": "application/json",
          "Authorization": "nabnee#" + localStorage.getItem("accessToken"),
          "_id": localStorage.getItem("_id"),
        },
      },
    };
  },
  methods: {
    createHashtag() {
      if (!this.newHashtag) return;
      this.isAdding = true;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "create_hashtag",
          { hashtag_text: this.newHashtag.trim() },
          this.auth
        )
        .then((res) => {
          this.isAdding = false;
          this.message = res.data.success
            ? "Hashtag created successfully!"
            : (res.data.message || "Failed to create hashtag.");
          this.newHashtag = "";
        })
        .catch(() => {
          this.isAdding = false;
          this.message = "Error creating hashtag.";
        });
    },
  },
};
</script>
<style scoped>
.hashtag-manager-page {
  padding: 32px;
  max-width: 500px;
  margin: auto;
}
</style>